/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![CreditCardIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAoUlEQVR4nGNgGAXEgNDQUDa/gPBOX//wZ34BEf8pwb4B4U/9AiI6QGbCLQAJUGqwHybugFtADZf7oWP/iOfIPvhPC8wwCogGNI8Dv2Flgb9/uBWuoPQJiLRBNwRZPbo8VgtAinBZ4O8fbotuAbJ6dPnBE0Q+WIKGbAuwBZE/lqAhyQJoEUvtIHpC0+La1z+iHa3Cieighk98sVU4o4ABDwAAHLpFb/J6dgsAAAAASUVORK5CYII=)
 */
export const CreditCardIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M1 6a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v1H1V6Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M1 10h22v8a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3v-8Zm4 3a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H5Zm-1 4a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Zm13-4a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
